var _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationTimeUpdated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 30,
    viewBox: "0 0 33 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4869 6.85714C20.0427 6.85714 20.4934 7.30777 20.4934 7.86364V13.1566C20.4934 14.3501 19.8559 15.4527 18.8215 16.0482L16.8898 17.1603C16.4391 17.4198 15.8641 17.2821 15.58 16.8465C15.2722 16.3746 15.4245 15.741 15.9132 15.4608L17.2543 14.6917C18.0127 14.2568 18.4804 13.4494 18.4804 12.5752V7.86364C18.4804 7.30777 18.931 6.85714 19.4869 6.85714ZM16.7396 25.7002C16.4962 26.4681 16.9679 27.2841 17.7696 27.3623C18.2209 27.4063 18.6815 27.4286 19.1514 27.4286C26.5323 27.4286 32.5713 21.2571 32.5713 13.7143C32.5713 6.17143 26.5323 0 19.1514 0C13.2904 0 8.20704 3.86026 6.4286 9.30807C6.15185 10.1558 6.82663 10.9714 7.71841 10.9714C8.36586 10.9714 8.92261 10.5297 9.14597 9.92204C10.6668 5.78407 14.5657 2.74286 19.1514 2.74286C25.0561 2.74286 29.8873 7.68 29.8873 13.7143C29.8873 19.7486 25.0561 24.6857 19.1514 24.6857C18.8514 24.6857 18.6323 24.6864 18.448 24.6802C17.7067 24.6553 16.9637 24.9932 16.7396 25.7002Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.71429,
    cy: 21.7143,
    r: 7.71429,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.85093 16.2861C8.50496 16.2861 9.03516 16.8163 9.03516 17.4704V22.3019C9.03516 22.9559 8.50496 23.4861 7.85093 23.4861C7.19689 23.4861 6.6667 22.9559 6.6667 22.3019V17.4704C6.6667 16.8163 7.19689 16.2861 7.85093 16.2861ZM7.85093 24.8861C8.50496 24.8861 9.03516 25.4163 9.03516 26.0704V26.1019C9.03516 26.7559 8.50496 27.2861 7.85093 27.2861C7.19689 27.2861 6.6667 26.7559 6.6667 26.1019V26.0704C6.6667 25.4163 7.19689 24.8861 7.85093 24.8861Z",
    fill: "#F47A36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationTimeUpdated);
export default __webpack_public_path__ + "static/media/notification-time-updated.e7071457b0ce154e1cff1df375406af9.svg";
export { ForwardRef as ReactComponent };